<header>
  <!-- Start desktop view block -->
  <div class="desktop-header">
    <!-- Customer Search  -->
    <div class="search__container" [ngClass]="{'search__container_hidden': checkRolesToHidden(['SUPER ADMIN', 'ADMIN'])}">
      <mat-form-field class="custom-mat-form-field search__form-field" floatLabel="never">
        <img matPrefix class="themified-white-icon search__icon search__icon-look" src="/assets/icons/magnifying-glass-icon.png"/>
        <input matInput placeholder="{{ 'general.search.label.search_for_customer' | translate }}" [formControl]="searchFormControl" (keyup.enter)="goCustomer()">
<!--         <img matSuffix class="themified-white-icon search__icon search__icon-clear" src="/assets/icons/cross-icon.png" (click)="resetCustomersSearch()"
             *ngIf="searchFormControl.value"/>        -->
      </mat-form-field>
<!--       <artemis-dropdown-menu class="dropdown_after-line" #customersDropdown
                             [class.no-hover]="customers && customers.length === 0">
        <ng-container dropdown-item *ngIf="customers && customers.length > 0">
          <a dropdown-item [title]="customer.name" (click)="selectCustomer(customer)"
             *ngFor="let customer of customers" [routerLink]="['/customers/' + customer.id]">
            {{customer.name}}
          </a>
        </ng-container>
        <span *ngIf="customers && customers.length === 0" dropdown-item>No data available</span>
      </artemis-dropdown-menu> -->
      <div class="customers-filter">
        <mat-form-field class="custom-mat-form-field customers-filter__form-field">
          <mat-label>{{ 'general.search.label.filter_by' | translate }}</mat-label>
          <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
          <mat-select multiple panelClass="custom-mat-optgroup" (selectionChange)="onSelectionChangeHandler($event)" [(ngModel)]="matSelect">
            <ng-container *ngFor="let filter of filterSettings">
              <mat-optgroup [label]="filter.title">
                <mat-option *ngFor="let item of filter.items" [value]="item">
                  {{item.label ? item.label : item.key}}
                </mat-option>
              </mat-optgroup>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
      <button mat-button (click)="goCustomer()" class="btn btn_rounded search__go-customer-button" ubi-round-button
              [disabled]="!searchFormControl.value && !searchAllParam">
        {{ 'general.search.title' | translate }}
      </button>
    </div>
    <!-- End Customer Search -->
    <!-- Right panel with user info -->
    <div class="right-panel">
      <!-- Right panel top row -->
      <div class="right-panel__top-row">
        <img class="themified-white-icon right-panel__profile-icon" src="/assets/icons/user-profile-icon.png"/>
        <span class="right-panel__profile-name" [title]="(profileStore$ | async).user?.name">{{(profileStore$ | async).user?.name}}</span>
        <div class="right-panel__menu-trigger-container" [artemisDropdownToggler]="pagesDropdownMenu">
          <img class="themified-white-icon right-panel__menu-trigger-icon" src="/assets/icons/chevron-down-icon.png"/>
        </div>
        <artemis-dropdown-menu class="dropdown_after-line" #pagesDropdownMenu>
          <a class="right-panel__dropdown-item" dropdown-item routerLink="/account-settings" title="Profile settings"> {{ 'dropdown.title.account_settings' | translate }} </a>
          <a class="right-panel__dropdown-item" dropdown-item routerLink="/user-guide" title="User Guide"> {{ 'dropdown.title.user_guide' | translate }}</a>
          <a class="right-panel__dropdown-item" dropdown-item title="Log out" (click)="logOut()"> {{ 'dropdown.title.log_out' | translate }} </a>
        </artemis-dropdown-menu>
      </div>
      <!-- End right panel top row -->
      <!-- Right panel bottom row -->
      <div class="right-panel__bottom-row">
        <div class="right-panel__sub-section" [title]="roles$ | async">
          <span class="right-panel__secondary-text">{{roles$ | async}}</span>
        </div>
        <div class="right-panel__sub-section" [title]="(currentDomainStore$ | async)?.domainName">
          <span class="right-panel__secondary-text" title="{{(currentDomainStore$ | async)?.domainName}}">{{(currentDomainStore$ | async)?.domainName}}</span>
          <img class="themified-white-icon right-panel__button-icon" src="/assets/icons/switch-icon.png" title="Change Domain" (click)="selectDomain()"/>
        </div>
        <div class="right-panel__sub-section right-panel__theme-toggler-container">
          <img class="right-panel__button-icon" [src]="isCurrentThemeLight ? '/assets/icons/dark-theme-icon.svg' : '/assets/icons/dark-theme-on-icon.svg'" title="Light Theme"/>
          <mat-slide-toggle class="custom-mat-slide-toggle theme-toggle" artemisThemeSwitcher
                            [checked]="isCurrentThemeLight" (change)="themeChanged()"></mat-slide-toggle>
          <img class="right-panel__button-icon" [src]="isCurrentThemeLight ? '/assets/icons/light-theme-on-icon.svg' : '/assets/icons/light-theme-icon.svg'" title="Dark Theme"/>
        </div>

      </div>
      <!-- End right panel bottom row -->
    </div>
    <!-- End right panel user info -->
  </div>
  <!-- End desktop view block -->
  <!-- Start mobile view block -->
  <div class="mobile-header">
    <!-- Start top bar with icons -->
    <div class="top-bar" [class.top-bar_search-opened]="isSearchBarOpened">
      <img class="top-bar__logo" src="/assets/images/logo-image-only.png" routerLink="/dashboard">
      <div class="top-bar__right-side">
        <img *ngIf="!((roles$ | async) === 'ADMIN')" class="themified-white-icon top-bar__search-icon" src="/assets/icons/magnifying-glass-icon.png" (click)="toggleMobileSearchBar()"/>
        <img class="themified-white-icon top-bar__menu-icon" src="/assets/icons/menu-icon.png" (click)="toggleSidebarClick()"/>
      </div>
    </div>
    <!-- End top bar with icons -->
    <!-- Start search bar with search customers -->
    <div class="search-bar" [@fadeInOut]="isSearchBarOpened"
         [ngClass]="{'search-bar_opened': isSearchBarOpened,
                     'search-bar_dropdown-opened': customersDropdown.dropdownOpened}">
      <div class="search-bar__input-container">
        <img class="themified-white-icon search-bar__icon search__icon-search" src="/assets/icons/magnifying-glass-icon.png"/>
        <input class="search-bar__input" placeholder="SEARCH" [formControl]="searchFormControl" (focus)="focusSearchInputsHandler($event)">
      </div>
      <div class="search-bar__icon-clear-container">
        <img class="themified-white-icon search-bar__icon search-bar__icon-clear" src="/assets/icons/cross-icon.png" (click)="resetCustomersSearch()"/>
      </div>
      <artemis-dropdown-menu class="dropdown_after-line" #customersDropdown
                             [class.no-hover]="customers && customers.length === 0">
        <ng-container dropdown-item *ngIf="customers && customers.length > 0">
          <a dropdown-item [title]="customer.name" (click)="selectCustomer(customer)"
             *ngFor="let customer of customers" [routerLink]="['/customers/' + customer.id]">
            {{customer.name}}
          </a>
        </ng-container>
        <span *ngIf="customers && customers.length === 0" dropdown-item> {{ 'dropdown.message.no_data' | translate }} </span>
      </artemis-dropdown-menu>
    </div>
    <!-- End search bar with search customers -->
  </div>
  <!-- End mobile view block -->
</header>
